import { Eved } from '@/event-bus'

// EventBus.$on(Eved.RFP.CREATED)

setTimeout(() => {
  //
  global.app.$pubnub && global.app.$pubnub.subscribe({
    channels: ['hello_world']
  })

  //
  global.app.$pubnub && global.app.$pubnub.addListener({
    status: function(statusEvent) {
      if (statusEvent.category === 'PNConnectedCategory') {
        // handle status
      }
    },
    message: function(message) {
      console.log('New Message!', message)
      Eved.queue.push(message)
      global.app.$notifications.notify({
        type: 'plain',
        icon: 'inbox',
        message: `<p>${message.message.data}</p>`,
        placement: { from: 'top', align: 'center' }
      })
    },
    presence: function(presenceEvent) {
      // handle presence
    }
  })
  //
})



// WEBPACK FOOTER //
// ./src/core/notifications/index.js